import { render, staticRenderFns } from "./sub-list.vue?vue&type=template&id=03b36b8e&scoped=true&"
import script from "./sub-list.vue?vue&type=script&lang=js&"
export * from "./sub-list.vue?vue&type=script&lang=js&"
import style0 from "./sub-list.vue?vue&type=style&index=0&id=03b36b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b36b8e",
  null
  
)

export default component.exports